export default {
      id: "one-up-drawer-open-usage",
      viewBox: "0 0 988 776",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#one-up-drawer-open",
      toString: function () {
        return this.url;
      }
    }